import React from "react";
import { images } from "../../constants";
import AppWrap from "../../wrapper/AppWrap";

const Footer = () => {
  return (
    <section className="space-y-8">
      <div className="rounded-3xl border border-white/10 bg-gradient-to-r from-primary/20 via-accent/20 to-primaryDark/15 backdrop-blur-xl shadow-2xl p-8 sm:p-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="space-y-2">
          <p className="text-sm uppercase tracking-[0.3em] text-primary">Let&apos;s build</p>
          <h3 className="text-3xl font-bold text-white">Have a product in mind?</h3>
          <p className="text-slate-200 max-w-xl">
            Tell me about the problem, the users, and the outcome you want. I&apos;ll reply with a plan the same day.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 text-xs">
          <a
            href="mailto:com.nishanneupane@gmail.com"
            className="flex items-center gap-3 px-5 py-4 rounded-2xl bg-white/10 border border-white/20 text-white hover:border-white/40 transition-colors"
          >
            <img src={images.email} alt="email" className="w-8 h-8" />
            com.nishanneupane@gmail.com
          </a>
          <a
            href="tel:+9779866284484"
            className="flex items-center gap-3 px-5 py-4 rounded-2xl bg-white/5 border border-white/15 text-white hover:border-white/30 transition-colors"
          >
            <img src={images.mobile} alt="mobile" className="w-8 h-8" />
            9866284484
          </a>
        </div>
      </div>


    </section>
  );
};

export default AppWrap(Footer, "footer");
